import React, { useState } from 'react';
import { Phone } from 'lucide-react';
import loginbg from '../../assets/images/loginbg.webp';
import { validateMobile, handleMobileChange, isMobileValidForSubmission, validateMobileComplete, getMobileInputProps } from '../../Utils/mobileValidation';

export default function LoginwithOtp() {
  const [mobileNumber, setMobileNumber] = useState('');
  const [mobileError, setMobileError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSendOTP = () => {
    // Use comprehensive mobile validation (both input and value)
    const validationResult = validateMobileComplete(mobileNumber, "Mobile Number", true);
    if (validationResult.isValid) {
      setIsLoading(true);
      // Simulate API call
      setTimeout(() => {
        setIsLoading(false);
        alert(`OTP sent to ${mobileNumber}`);
      }, 1500);
    } else {
      alert(validationResult.errorMessage);
    }
  };

  const handleInputChange = (e) => {
    // Use standardized mobile validation handler
    handleMobileChange(e.target.value, setMobileNumber, setMobileError, true);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendOTP();
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 ">
        <img src={loginbg} alt="Animated Background" />
        {/* Stars */}
       
        </div>

      {/* Login Form */}
      <div className="relative z-10 flex items-center justify-center min-h-screen">
        <div className="bg-white rounded-3xl shadow-2xl p-8 w-96 max-w-sm mx-4 backdrop-blur-sm bg-opacity-95">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-lg">
              <Phone className="w-8 h-8 text-white" />
            </div>
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-800 text-center mb-2">
            Enter your mobile number
          </h2>
          
          {/* Subtitle */}
          <p className="text-gray-500 text-center mb-8 text-sm">
            We will send you an SMS with a One Time Password (OTP)
          </p>

          {/* Form */}
          <div className="space-y-6">
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Mobile Number
              </label>
              <input
                {...getMobileInputProps(mobileNumber, setMobileNumber, setMobileError, true, true, true)}
                onKeyPress={handleKeyPress}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-all duration-200 text-gray-700"
                disabled={isLoading}
              />
              {mobileNumber && (
                <p className="text-xs text-gray-500 mt-1">
                  {mobileNumber.length}/10 digits
                </p>
              )}
              {mobileError && (
                <p className="text-red-500 text-xs mt-1">{mobileError}</p>
              )}
            </div>

            <button
              onClick={handleSendOTP}
              disabled={!validateMobileComplete(mobileNumber, "Mobile Number", true).isValid || isLoading}
              className={`w-full py-3 px-4 rounded-lg font-medium text-white transition-all duration-200 transform ${
                !validateMobileComplete(mobileNumber, "Mobile Number", true).isValid || isLoading
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-red-500 hover:bg-red-600 hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl'
              }`}
            >
              {isLoading ? (
                <div className="flex items-center justify-center">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                  Sending...
                </div>
              ) : (
                'Send OTP'
              )}
            </button>
          </div>

          {/* Additional Actions */}
          <div className="mt-6 text-center">
            <button 
              onClick={() => setMobileNumber('')}
              className="text-gray-500 hover:text-gray-700 text-sm transition-colors duration-200"
              disabled={isLoading}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}